import * as React from "react";
function SvgCrossIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={15.46} height={15.46} viewBox="0 0 15.46 15.46" {...props}><g transform="translate(0)"><g transform="translate(-0.27)"><path d="M0,0H18.762V2.1H0Z" transform="translate(2.463 0) rotate(45)" /><path d="M.044.339H18.806v2.1H.044Z" transform="translate(0 13.766) rotate(-45)" /></g></g></svg>;
}
export default SvgCrossIcon;